
export function fitTextToBox(text, textString, boxWidth, boxHeight, baseFont = "Arial", maxFontSize = 100) {
	let fontSize = maxFontSize;
	// let text = scene.add.text(0, 0, textString, { font: `${fontSize}px ${baseFont}`, wordWrap: { width: boxWidth } });
	// console.log("boxWidth ", boxWidth)
	// console.log("boxHeight ", boxHeight)
	
	while (fontSize > 10) { // Stop at a reasonable minimum size
		let bounds = text.getBounds();
		// console.log("bounds.width ", bounds.width)
		// console.log("bounds.height ", bounds.height)
		if (bounds.width <= boxWidth && bounds.height <= boxHeight) {
			break; // Stop when the text fits
		}
		fontSize--; // Reduce font size
		text.setFontSize(fontSize);
	}

	// Center the text inside the box
	// text.setPosition(boxWidth / 2 - text.width / 2, boxHeight / 2 - text.height / 2);

}
